import { sortBy } from 'lodash';

function getNextSbatLectureId(lectureList, referenceDate) {
  const sortedLectureList = sortBy(lectureList, function (o) {
    return o.date_of_topic;
  });

  for (const lecture of sortedLectureList) {
    if (new Date(lecture.date_of_topic) >= new Date(referenceDate)) {
      return lecture.id;
    }
  }
  return null;
}

export default getNextSbatLectureId;
